import useSWR from "swr";

export const useFetchSegmentDeliveriesCount = (restaurantId: string, startDate: string|null, endDate: string|null) => {
  const { data: segmentDeliveriesCount, error, isLoading } = useSWR<number>(`membership/restaurants/${restaurantId}/line/segment-deliveries/counts/?startDate=${startDate}&endDate=${endDate}`)
  return { segmentDeliveriesCount, isLoading, error };
};